import React, { Component } from "react";
import PropTypes from "prop-types";
import MediaQuery from "react-responsive";

export class LandscapeOnly extends Component {
    render() {
        return <MediaQuery query="(orientation: landscape)">{this.props.children}</MediaQuery>;
    }
}

LandscapeOnly.propTypes = {
    children: PropTypes.object
};
